import { render, staticRenderFns } from "./Entries.vue?vue&type=template&id=596c0056"
import script from "./Entries.vue?vue&type=script&lang=js"
export * from "./Entries.vue?vue&type=script&lang=js"
import style0 from "./Entries.vue?vue&type=style&index=0&id=596c0056&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports